<template lang="pug">
section
    .flex-row
        el-form-item.grow(:label="$t('Name')" prop="name")
            el-input(type="text" v-model="name")
        el-form-item.key-field.grow(:label="$t('Key')" prop="key")
            el-input(type="text" v-model="key")
        el-form-item.colorpicker(:label="$t('Color')" prop="color")
            el-color-picker(
                v-model="color"
                ref="colorpicker"
                color-format="hex"
                @active-change="updateSecondaryColorPreview"
            )
            el-tooltip(effect="dark" :content="$t('Product page')" placement="bottom")
                .secondary-color-preview(:style="{ 'background-color': secondaryColor }")
    el-form-item.no-margin(:label="$t('Description')" prop="description")
        quill-editor(v-model="description" :options="quillConfig")
</template>

<i18n>
{
    "de": {
        "Key": "Eindeutige Kennung",
        "Name": "Name",
        "Color": "Farbe",
        "Description": "Beschreibung"
    }
}
</i18n>

<script>

import _ from 'lodash'
// import Vue from 'vue'
import Color from 'color'
import { mapGetters } from 'vuex'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import quillConfig from '@/quill/config'
import store from '@/store'

export default {
    name: 'Main',
    data() {
        quillConfig.modules.link.pages = this.pageOptions
        return {
            quillConfig,
            secondaryColorPreview: undefined,
        }
    },
    watch: {
        '$refs.colorpicker.showPicker': function (value) {
            // eslint-disable-next-line
            // console.log('>', value)
        }
    },
    computed: {
        name: {
            get() {
                return _.get(this.form, 'name', '')
            },
            set(value) {
                store.commit('ext_marketing_campaign/form/name', value)
                if (! _.get(this.form, 'id')) {
                    const key = _.kebabCase(value);
                    store.commit('ext_marketing_campaign/form/key', key)
                }
            }
        },
        key: {
            get() {
                return _.get(this.form, 'key', '')
            },
            set: value => store.commit('ext_marketing_campaign/form/key', value)
        },
        color: {
            get() {
                return _.get(this.form, 'color') || '#6b52ef'
            },
            set: value => store.commit('ext_marketing_campaign/form/color', value)
        },
        description: {
            get() {
                return _.get(this.form, 'description', '')
            },
            set: value => store.commit('ext_marketing_campaign/form/description', value)
        },
        secondaryColor() {
            if (this.$refs.colorpicker && this.$refs.colorpicker.showPicker)
                return this.secondaryColorPreview || this.getSecondaryColor(this.color)

            // TODO: move to setter
            this.secondaryColorPreview = undefined
            return this.getSecondaryColor(this.color)
        },
        // isUpdate() {
        //     return !! _.get(this.form, 'id')
        // },
        ...mapGetters({
            form: 'ext_marketing_campaign/form',
        }),
    },
    methods: {
        updateSecondaryColorPreview(string) {
            const rgbToHex = string => {
                const rgb = string.split("(")[1].split(")")[0].split(",").map(el => parseInt(el));
                return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1)
            };
            this.secondaryColorPreview = this.getSecondaryColor(rgbToHex(string));
        },
        getSecondaryColor(hex) {
            let color = Color(hex)
            return color
                // .lighten(0.35)
                // .desaturate(0.5)
                // .rotate(20)
                .fade(0.5)
                // .fade(0.5)
                .rgb()
                .string()
        }
    },
    // mounted() {
    //     console.log(this.$refs.colorpicker)
    // }
}
</script>

<style lang="sass" scoped>
.flex-row
    display: flex
    justify-content: space-between
    .grow
        flex-grow: 1
        margin-right: 1rem
    .key-field
    .el-form-item:last-child
        margin-right: 0

.secondary-color-preview
    width: 36px
    height: 36px
    background: red
    display: inline-block
    border-radius: 4px
    border: 1px solid rgb(230, 230, 230)
    width: 24px
    height: 24px
</style>
